export enum BulkAction {
  PAYMENT_REQUEST = <any>'PAYMENT_REQUEST',
  PAID_DIRECT = <any>'PAID_DIRECT',
  CANCELLED = <any>'CANCELLED'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/bulk-action.ts